import { gql, QueryResult, useQuery } from "@apollo/client";

import { User } from "../../../generated/gql/graphql";

const GET_USER = gql`
  query Me {
    me {
      email
      isAdmin
      name
      permissions
      username
      id
      groups
      activeClientId
      clientIds
      clients {
        id
        name
      }
    }
  }
`;

export default function useUser(): QueryResult<{ me: User }> {
  return useQuery(GET_USER, {
    fetchPolicy: "network-only",
  });
}
